import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import { useFragment } from "react-relay";

import { VerifiedAuthenticationModal } from "@/features/Authentication/components/AuthenticationModal";
import { Loader } from "@whoosh/design-system/src/components/display";

import { goToPageAtom } from "../atoms";
import { StorePackageAuth_session$key } from "./__generated__/StorePackageAuth_session.graphql";

type Props = {
  sessionRef?: StorePackageAuth_session$key | null;
  onAuthComplete?: () => void;
};

export const StorePackageAuth = ({ sessionRef, onAuthComplete }: Props) => {
  const goToPage = useSetAtom(goToPageAtom);
  const session = useFragment(
    StorePackageAuthSessionFragmentString,
    sessionRef
  );

  const club = session?.currentClientProfile?.member?.club;
  const clubSlug = club?.slug;
  const sessionClub = club
    ? {
        id: club.id,
        slug: club.slug,
        name: club.name,
        logoImage: club.logoImage?.publicId || "",
        supportsPublic: club.supportsPublic,
      }
    : null;

  const onClose = () => {
    goToPage({ page: "DETAIL" });
  };

  const onComplete = () => {
    onAuthComplete?.();
    goToPage({ page: "DETAIL" });
  };

  return (
    <VerifiedAuthenticationModal
      fallBack={<Loader />}
      onClose={onClose}
      clubSlug={clubSlug}
      onComplete={onComplete}
      sessionClub={sessionClub}
    />
  );
};

const StorePackageAuthSessionFragmentString = graphql`
  fragment StorePackageAuth_session on Session {
    currentClientProfile {
      member {
        club {
          id
          slug
          name
          supportsPublic
          logoImage {
            # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
            publicId: renderingKey
          }
        }
      }
    }
  }
`;
